export enum AccordionState {
  OPEN = 'open',
  COLLAPSED = 'collapsed',
}
